module.exports = __webpack_public_path__ + "img/empty-box@2x.008480b5.png";